import { InputGroup } from 'react-bootstrap';
import { InputNumber } from '../../../../Utiles/Inputs';
import { CardMain, SizeViewSelector, Title, Guardar, ButtonColor, TitleCard, CardConfig, RowConfig } from '../../Component';
import { TBElementItens } from '../../Component/Commons';
import { State, iten } from './index'
import { ConfigIten } from './Itens/Config';
import { Selector } from './Selector';
interface Props {
    save: () => void
    iten: iten;
    title: string;
    config: State;
    setTitle: (d: string) => void;
    setConfig: (d: any) => void,
    setIten: (d: Partial<iten>) => void
    itenUp: (d: number) => void
    itenDown: (d: number) => void
    addIten: () => void
    removeItem: (d: number) => void
}
export function Config({ save, title, config, setTitle, setConfig, setIten, iten, itenUp, itenDown, addIten, removeItem }: Props) {
    const { size, width, gap, animated, color, itens: { length } } = config;
    const { back } = iten;
    return <CardMain>
        <Guardar guardar={save} />
        <CardConfig width="287px">
            <RowConfig >
                <Title setData={setTitle} title={title} width='100%' />
            </RowConfig>
            <RowConfig top={2}>
                <Selector ani={animated} set={(animated) => setConfig({ animated })} />
            </RowConfig>
            <TitleCard>CONFIGURACION GENERAL</TitleCard>
        </CardConfig>
        <ConfigIten addItem={addIten} cont={length} size={width} gap={gap} iten={iten} setConfig={setIten} itenUp={itenUp} itenDown={itenDown} removeItem={removeItem} />
        <TBElementItens back={back} setBack={back => setIten({ back })} />
        <CardConfig width="76px">
            <RowConfig>
                <InputGroup data-tip='TAMAÑO DE LA IMAGENES EN RELACION 1:1' className='input-group-sm' style={{ height: '24px', width: 70 }}>
                    <InputGroup.Prepend style={{ height: '24px', width: '30px' }}>
                        <InputGroup.Text style={{ height: '24px', width: '30px' }}>
                            <i style={{ border: 'solid 1px currentColor' }} className="fas fa-arrows"></i>
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <InputNumber max={450} min={150} step={1} decimal={0} style={{ height: 24 }} value={width} setData={width => setConfig({ width })} />
                </InputGroup>
            </RowConfig>
            <RowConfig top={2}>
                <InputGroup data-tip='ESPACIO ENTRE LAS IMAGENES' className='input-group-sm' style={{ height: '24px', width: 70 }}>
                    <InputGroup.Prepend style={{ height: '24px', width: '38px' }}>
                        <InputGroup.Text style={{ height: '24px', width: '38px' }}>
                            <i style={{ borderLeft: 'solid 3px currentColor', borderRight: 'solid 3px currentColor' }} className="fas fa-arrows-h"></i>
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <InputNumber max={width * .1} step={1} min={0} decimal={0} style={{ height: 24 }} value={gap} setData={gap => setConfig({ gap })} />
                </InputGroup>
            </RowConfig>
            <RowConfig top={2}>
                <ButtonColor tip='COLOR DE FONDO DE LA GALERIA' color={color} setData={(color) => setConfig({ color })}>
                    <i className="fas fa-paint-roller"></i>
                </ButtonColor>
            </RowConfig>
            <TitleCard>CUADRICULA</TitleCard>
        </CardConfig>
        <SizeViewSelector setSize={(size) => setConfig({ size })} size={size} />
    </CardMain>
}